<template>
  <div>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>

    <!-- Data table -->
      <v-card>
          <v-card-title>
              <v-row>
                  <v-col cols="12" md="4" sm="12">
                      <v-btn v-if="! isOperator" rounded class="mr-5" depressed color="primary" @click="handleAdd()">
                          <v-icon class="mr-1"> mdi-plus-circle </v-icon>
                          {{ $t("addNew") }}
                      </v-btn>
                  </v-col>

                  <v-col cols="6" md="2" sm="6">
                      <v-menu
                          v-model="menuDateFrom"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                      >
                          <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="from_date"
                                  :label="$t('dateFrom')"
                                  prepend-inner-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                              ></v-text-field>
                          </template>
                          <v-date-picker
                              :first-day-of-week="0"
                              v-model="from_date"
                              @input="menuDateFrom = false"
                          ></v-date-picker>
                      </v-menu>
                  </v-col>

                  <v-col cols="6" md="2" sm="6">

                      <v-menu
                          v-model="menuDateTo"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                      >
                          <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="to_date"
                                  :label="$t('dateTo')"
                                  prepend-inner-icon="mdi-calendar"
                                  outlined
                                  dense
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  clearable
                              ></v-text-field>
                          </template>
                          <v-date-picker
                              :first-day-of-week="0"
                              v-model="to_date"
                              @input="menuDateTo = false"
                          ></v-date-picker>
                      </v-menu>
                  </v-col>

                  <v-col cols="6" md="2" sm="6">
                      <v-text-field
                          v-model="search"
                          :label="$t('search')"
                          single-line
                          outlined
                          dense
                          clearable
                      >
                      </v-text-field>
                  </v-col>

                    <v-col cols="12" md="2" sm="12">
                      <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleSearch()">
                          <v-icon class="mr-1"> mdi-magnify </v-icon>
                      </v-btn>

                      <v-btn @click="exportExcel('exportExcel')" outlined>
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
                      </v-btn>
                  </v-col>
              </v-row>
          </v-card-title>

        <v-data-table
          id="exportExcel"
          :loading="loading"
          :headers="headers"
          :items="listProductCheckIn"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
        >

          <!-- Progressive -->
          <template v-slot:progress style="text-align: center"><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

          <!-- Header -->
          <template v-slot:header.date="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.reference="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.supplier_name="{ header }"> {{ $t(header.text) }}</template>
          <template v-slot:header.client_name="{ header }"> {{ isOperator ? $t(header.text) : ''}}</template>
          <template v-slot:header.total_amount="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.paid_status="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

          <!-- Body -->
          <template v-slot:item.date="{ item }">{{ item.date | dateFormat}}</template>
          <template v-slot:item.from_contact_name="{ item }"> {{ item.from_contact_name }} </template>
          <template v-slot:item.client_name="{ item }"> {{ isOperator ? item.client_name : ''}} </template>
          <template v-slot:item.total_amount="{ item }">{{ parseFloat(item.total_amount) | formatNumber }}{{ getCurrencySymbol(item.currency_code) }}</template>
          <template v-slot:item.paid_status="{ item }"><v-chip small outlined :color="getColor(item.paid_status)" dark>{{ $t(item.paid_status) }}</v-chip></template>

          <!-- Action -->
          <template v-slot:item.action="{ item }">
            <v-btn color="success" small rounded class="table-action-button no-text-transform mr-2" v-if="(item.paid_status !== 'paid') && (! isOperator)" @click="handlePayment(item.id, $event)"><font-awesome-icon icon="dollar-sign" class="mr-1"/> {{ $t('payment') }}</v-btn>
            <!-- <v-btn color="primary" outlined class="table-action-button mr-2" text icon :disabled="true" @click="handleEdit($event, item)"><font-awesome-icon icon="edit"/></v-btn> -->
            <!-- <v-btn color="error" outlined class="table-action-button mr-2" text icon :disabled="true"> <font-awesome-icon icon="trash"/></v-btn> -->
            <v-btn color="teal" outlined class="table-action-button" text icon :disabled="true" :to="{ name: 'stock-transfer-print', params: { id: item.id}}"><font-awesome-icon icon="print"/></v-btn>
          </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>

            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
              <v-select
                  :label="$t('perPage')"
                  v-model="itemsPerPage"
                  :items="pageList"
              ></v-select>
            </v-col>

            <v-pagination
                v-model="currentPage"
                :length="pageCount"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
            ></v-pagination>

            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">

              <v-text-field
                  v-model="currentPageComputed"
                  :max="pageCount"
                  min="1"
                  type="number"
                  :label="$t('goto')"
              ></v-text-field>
            </v-col>
          </v-card-actions>
        </div>
      </v-card>
    <!-- End Data table -->

    <!-- Form control -->
      <v-form v-model="valid" ref="formData" lazy-validation>
        <v-dialog v-model="dialog" persistent fullscreen>
          <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
          <v-card>
            <v-card-title class="dialog-header">
              <span class="headline" v-if="toggleAdd">{{ $t("addPurchasing") }}</span>
              <span class="headline" v-if="!toggleAdd">{{$t("editPurchasing")}}</span>
              <v-spacer></v-spacer>
              <v-btn fab text icon @click="handleClose()" v-shortkey="['esc']" @shortkey.native="handleClose()"><font-awesome-icon style="font-size: 20px;color: white" icon="times"/></v-btn>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" sm="3" md="3" class="seperate-line-verticle">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-autocomplete
                        v-model="formDoc.supplier_id"
                        :items="listWalkinMember"
                        outlined
                        :dense="dense"
                        item-text="text"
                        item-value="id"
                        :label="$t('supplier') + '*'"
                        :rules="selectRules"
                        required
                      >
                        <template v-slot:selection="{ item }">{{ item.text }}</template>
                        <template v-slot:item="{ item }">{{ item.text }}</template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        dense
                        v-model="formDoc.supplier_name"
                        :label="$t('supplierName')"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        dense
                        v-model="formDoc.supplier_phone"
                        :label="$t('supplierPhone')"
                        :rules="phoneRulesOptional"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-select
                        :items="currencyOptionList"
                        :label="$t('currency') + '*'"
                        outlined
                        v-model="formDoc.currency_code"
                        :rules="selectRules"
                        item-text="text"
                        item-value="id"
                        dense
                      >
                        <template v-slot:selection="{ item }">{{ item.text }}</template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-select
                        :items="paymentMethod"
                        :label="$t('paymentMethod') + '*'"
                        outlined
                        v-model="formDoc.payment_method"
                        :rules="requireRules"
                        dense
                        disabled
                      >
                        <template v-slot:selection="{item}">{{ $t(item) }}</template>
                        <template v-slot:item="{item}">{{ $t(item) }}</template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-menu
                        v-model="menuDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formDoc.date"
                            :label="$t('date') + '*'"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            :rules="dateRules"
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            :first-day-of-week="0"
                            v-model="formDoc.date"
                            :rules="dateRules"
                            @input="menuDate = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        outlined
                        dense
                        v-model="formDoc.reference"
                        :label="$t('reference')"
                        :disabled="!toggleAdd"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="9" md="9">
                  <v-row>
                    <v-col cols="5" sm="4" md="4">
                      <v-autocomplete
                          v-model="filterDoc.category_id"
                          :items="categoryOptionList"
                          outlined
                          clearable
                          :dense="dense"
                          auto-select-first
                          item-text="text"
                          item-value="id"
                          :label="$t('category')"
                          :placeholder="$t('pleaseChooseCategory')"
                          required
                      >

                        <template v-slot:selection="{ item }">
                          {{ item.text }}
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="7" sm="8" md="8">
                      <v-autocomplete
                          v-model="filterDoc.product_id"
                          :items="listProductOutsideEco"
                          outlined
                          :dense="dense"
                          item-text="name"
                          item-value="variation_id"
                          clearable
                          :label="$t('product')"
                          :placeholder="$t('pleaseChooseProduct')"
                          required
                      >
                        <template v-slot:selection="{ item }">
                          {{ item.name }}
                        </template>
                        <template v-slot:item="{ item }">
                          {{ item.sku+': '+ item.name }}
                        </template>
                      </v-autocomplete>
                    </v-col>
                    
                    <v-col cols="12" md="12" sm="12">
                      <v-data-table
                        :headers="transferHeader"
                        :items="transaction_line"
                        hide-default-footer
                        mobile-breakpoint="0"
                      >
                        <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
                        <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
                        <template v-slot:header.cost="{ header }">{{ $t(header.text) }}</template>
                        <template v-slot:header.ab_fee="{ header }">{{ header.text }}</template>
                        <template v-slot:header.product_description="{ header }">{{ $t(header.text) }}</template>
                        <template v-slot:header.amount="{ header }">{{ $t(header.text) }}</template>
                        <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>
                        <template v-slot:item.qty="{ item }">
                          <v-text-field
                            style="width: 150px"
                            type="number"
                            min="1"
                            v-model="item.qty"
                            @change.native="updateTransactionLine(item)"
                            @keyup.native="updateTransactionLine(item)"
                            hide-details="auto"
                            :suffix="item.unit_name"
                            dense
                            ></v-text-field>
                          </template>

                          <template v-slot:item.cost="{ item }">
                            <v-text-field
                              style="width: 150px"
                              type="number"
                              min="1"
                              v-model="item.cost"
                              @change.native="updateTransactionLine(item)"
                              @keyup.native="updateTransactionLine(item)"
                              hide-details="auto"
                              :suffix="item.currency_symbol"
                              dense
                            ></v-text-field>
                          </template>

                        <template v-slot:item.product_description="{ item }">
                          {{
                            item.product_description && item.product_description.substr(0, 9) || ""
                          }}{{
                            item.product_description && item.product_description.length > 9 ?
                                "..." : ""
                          }}
                        </template>
                        <template v-slot:item.ab_fee="{ item }">{{ item.ab_fee | formatNumber }}{{ item.currency_symbol }}</template>
                        <template v-slot:item.amount="{ item }">{{ item.amount | formatNumber }}{{ item.currency_symbol }}</template>
                        <template v-slot:item.action="{ item }">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            outlined
                            @click="handRemoveDetail(item)"
                            color="error"
                          >
                            <v-icon dark>mdi-minus</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>

                    <v-col sm="8" cols="2" style="text-align: right;"><h3>{{ $t("totalAmount") }} :</h3></v-col>
                    <v-col
                      cols="10"
                      sm="4"
                      style="background-color: lightgray;font-weight: bold;font-size: 25px"
                    >
                      {{ formDoc.total_amount | formatNumber }}{{ currency_symbol }}
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                          clearable
                          v-model="formDoc.note"
                          clear-icon="mdi-close-circle"
                          rows="4"
                          outlined
                          :placeholder="$t('yourDesc')"
                          auto-grow
                          :label="$t('note')"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="reset">Reset</v-btn>
                <!-- <v-btn rounded @click="submit($event,true)" style="min-width: 150px" color="primary"><font-awesome-icon icon="check-circle" class="mr-2"/>{{$t('saveAndPrint')}}</v-btn> -->
                <v-btn :disabled="formDoc.payment_method === 'cash'" rounded @click="submit($event,true)" style="min-width: 150px" color="warning"><font-awesome-icon icon="dollar-sign" class="mr-2"/>{{$t('payment')}}</v-btn>
                <v-btn rounded @click="submit($event,false)" style="min-width: 150px" color="success"><font-awesome-icon icon="check-circle" class="mr-2"/>{{$t('save')}}</v-btn>
            </v-card-actions>

          </v-card>
        </v-dialog>
      </v-form>
    <!-- End Form control -->

     <!-- Payment section -->
      <sale-payment></sale-payment>
      <!-- End Payment section -->
  </div>
</template>

<script>
  import MainMixin from "../../../mixins/mainMixin";
  import ValidatorMixin from "../../../mixins/validatorMixin";
  import OptionDataMixin from "../../../mixins/optionDataMixin";
  import moment from "moment";
  import {provider} from "@/service/provider";
  import axios from "axios";
  import _ from "lodash";
  import salePayment from './salePayment';

  export default {
    name: "purchasing",
    mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
    components: {salePayment},
    data() {
      return {
        formDoc: {
          id: "",
          client_id: this.$store.state.userDoc.contact_id,
          supplier_id: "10001100110000002",
          supplier_name: "",
          supplier_phone: "",
          currency_code: "",
          payment_method: 'cash',
          date: moment().format("YYYY-MM-DD"),
          note: "",
          reference: "",
          total_amount: 0,
          user_id: this.$store.state.userDoc.id
        },

        filterDoc: {
          product_id: "",
          category_id: ""
        },

        headers: [
          {text: "date", align: "start", value: "date"},
          {text: "reference", value: "reference"},
          {text: "supplier", value: "supplier_name", sortable: false},
          {text: "client", value: "client_name", sortable: false},
          {text: "totalAmount", value: "total_amount"},
          {text: "status", value: "paid_status"},
          {text: "action", value: "action", sortable: false, width: 100}
        ],

        transferHeader: [
          {text: "name",align: "start",sortable: false,value: "name"},
          {text: "qty", value: "qty", width: 150, sortable: false},
          {text: "cost", value: "cost", sortable: false},
          {text: this.$t("ab_fee"), value: "ab_fee", sortable: false},
          {text: "amount", value: "amount", sortable: false},
          {text: "note", value: "product_description"},
          {text: "action", value: "action", width: 50, sortable: false}
        ],

        transaction_line: [],
        currency_symbol: "",
      };
    },

    methods: {

      fetchDataTable: _.debounce(function () {
        let vm = this;
        vm.loading  = true;
        vm.fetchProductCheckInOut({
          id: '',
          reference: '',
          type: 'checkin',
          search: vm.search,
          offset: vm.currentPage,
          limit: vm.itemsPerPage,
          sortBy: vm.options.sortBy[0] || "created_at",
          sortDesc: vm.options.sortDesc[0] === false ? 0 : 1,
          from_date: vm.from_date,
          to_date: vm.to_date,
        })
      }, 350),

      reset() {
        if (this.$refs.formData) {
          this.$refs.formData.reset();
          this.formDoc.date               = "";
          this.transaction_line  = [];
          this.calculateTotal();
        }
      },

      handleClose() {
        this.dialog = false;
        this.reset();
      },

      handleAdd() {
        let vm                      = this;
        vm.reset();
        vm.dialog                   = true;
        vm.toggleAdd                = true;
        vm.formDoc.id               = "";
        vm.formDoc.payment_method   = "cash";
        vm.formDoc.date             = moment().format("YYYY-MM-DD");
      },

      handleEdit(event, item) {
        event.preventDefault();
        let vm      = this;
        vm.formDoc  = {};
        vm.overlay  = true;
        vm.toggleAdd= false;
        let url     = provider.baseURL + provider.listProductCheckInOut;
        return new Promise((resolve, reject) => {
          axios.post(url, {
              id: item.id,
              reference: '',
              type: 'checkin',
              search: '',
              offset: 0,
              limit: 1,
          }, {headers: {Authorization: localStorage.token}}).then(
              res => {
                if (res.data.response && res.data.response.code === 200) {
                  vm.overlay = false;
                  vm.dialog = true;
                  resolve(res.data.data);
                  let newItem = res.data.data[0];

                  vm.filterDoc.category_id  = "";
                  vm.filterDoc.product_id   = "";
                  vm.formDoc                = Object.assign({}, newItem);
                  vm.formDoc.payment_method = vm.parseFromDate(vm.formDoc.payment_method);
                  vm.formDoc.date           = vm.parseFromDate(vm.formDoc.date);
                  vm.formDoc.total_amount   = parseFloat(vm.formDoc.total_amount);
                  vm.transaction_line       = [];
                  vm.transaction_line.push(...newItem.transaction_line);

                  vm.transaction_line.map((d) => {
                    d.currency_code = vm.formDoc.currency_code;
                    d.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
                    d.qty   = parseFloat(d.qty);
                    d.cost  = parseFloat(d.cost);
                    d.ab_fee= parseFloat(d.ab_fee);
                    d.price = parseFloat(d.price);
                    d.amount= parseFloat(d.amount);
                    return d;
                  })
                }
              },
              error => {
                reject(error);
              }
          );
        });


      },

      submit(e, isPayment) {
        e.preventDefault();
        let vm = this;
        if (vm.$refs.formData.validate()) {
          if(vm.transaction_line.filter(obj => { return obj.qty > 0 }).length){

              vm.overlay = true;
              vm.formDoc.user_id = localStorage.id;
              vm.transaction_line.map((d) => {
                d.qty = parseFloat(d.qty);
                d.price = parseFloat(d.price);
                d.cost = parseFloat(d.cost);
                d.amount = parseFloat(d.amount);
                return d;
              });

              vm.formDoc.note = vm.formDoc.note || "";
              vm.formDoc.transaction_line = vm.transaction_line;
              let newFormDoc = Object.assign({}, vm.formDoc);
              newFormDoc.date = vm.parseToDate(vm.formDoc.date);
              let url = provider.baseURL + provider.storeProductCheckin;

              return new Promise((resolve, reject) => {
                axios.post(url, newFormDoc, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                      if (res.data.response && res.data.response.code === 200) {
                        resolve(res.data.data.transaction_invoice_id);
                        vm.$notify({
                          title: "Success",
                          message: vm.$t("success"),
                          type: "success",
                          duration: 700
                        });
                        vm.dialog = false;
                        if (isPayment === true) {
                            vm.handlePayment(res.data.data.transaction_invoice_id);
                        }
                        // if (isPrint === true) {
                        //   vm.$router.push({
                        //     name: 'stock-transfer-print',
                        //     params: {id: res.data.data.transaction_invoice_id}
                        //   });
                        // }
                        vm.fetchDataTable();
                        vm.overlay = false;

                      }
                    },
                    error => {
                      reject(error);
                    }
                );
              });
          }
          else {
            vm.$notify({
                title: "Error",
                message: vm.$t("pleaseCheckProductPurchasing"),
                type: "error",
                duration: 2000
            });
          }

        }
      },
      
      handRemoveDetail(item) {
        let vm = this;
        vm.$confirm(vm.$t("thisWillDelete") + item.name + ' . ' + vm.$t('continue') + '?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

          vm.removeStockTransferLine(item);
          vm.$message({
            type: 'success',
            message: vm.$t('deleteComplete')
          });
        }).catch(() => {
          vm.$message({
            type: 'info',
            message: vm.$t('deleteCancel')
          });
        });
      },

      removeStockTransferLine(row) {
        let vm = this;
        let index = vm.transaction_line.findIndex(
            ind => ind.product_id === row.product_id
        );
        vm.transaction_line.splice(index, 1);
        vm.calculateTotal();

      },

      updateTransactionLine(row) {
        //When we update order line by change qty
        let vm = this;
        let newDoc = row;
        let index = vm.transaction_line.findIndex(
            ind => ind.product_id === row.product_id
        );

        let qty = 1;
        qty = +newDoc.qty;

        newDoc.qty = qty;
        newDoc.cost = vm.convertExchangeRate(row.currency_code, vm.formDoc.currency_code, parseFloat(row.cost || 0));
        newDoc.price = vm.convertExchangeRate(row.currency_code, vm.formDoc.currency_code, parseFloat(row.price || 0));
        newDoc.currency_code = vm.formDoc.currency_code;
        newDoc.currency_symbol = vm.getCurrencySymbol(vm.formDoc.currency_code);
        newDoc.amount = qty * parseFloat(newDoc.cost);
        vm.transaction_line[index] = newDoc;

        vm.$nextTick(() => {
          vm.calculateTotal();
          vm.filterDoc.product_id = "";
        });
        
      },

      addTransactionLine(val) {
        let vm = this;
        if (val) {
          let productDoc = vm.listProductOutsideEco.find(obj => obj.variation_id === val);
          if (productDoc) { //Check condition choose price up to depo , shop ,farmer

            /** check prodoct already choose */
            let checkExist = vm.transaction_line.find(od => od.variation_id === val);
            if (checkExist) {
              let current_qty = parseFloat(checkExist.qty);
              checkExist.qty  =  current_qty + 1;
              vm.updateTransactionLine(checkExist);
            } 
            else {
                let cost = vm.convertExchangeRate(productDoc.currency_code, vm.formDoc.currency_code, parseFloat(productDoc.cost || 0));
                let price= vm.convertExchangeRate(productDoc.currency_code, vm.formDoc.currency_code, parseFloat(productDoc.price || 0));

                vm.transaction_line.push({
                  name: productDoc.sku + ': ' + productDoc.name,
                  transaction_line_id: "",
                  product_id: productDoc.id,
                  variation_id: productDoc.variation_id,
                  qty: 1,
                  currency_code: vm.formDoc.currency_code,
                  currency_symbol: vm.getCurrencySymbol(vm.formDoc.currency_code),
                  unit_name: productDoc.unit_name,
                  unit_id: parseInt(productDoc.unit_id),
                  price: price,
                  cost: cost,
                  ab_fee: productDoc.ab_fee || 0,
                  amount: cost,
                  product_description: productDoc.product_description || "",
                });

                vm.$nextTick(() => {
                  vm.calculateTotal();
                  vm.filterDoc.product_id = "";
                });

                vm.$notify({
                  title: "Success",
                  message: vm.$t("addProductSuccess"),
                  type: "success",
                  duration: 1500
                });
            }
          }

        }
      },

      calculateTotal() {
        let vm = this;
        vm.formDoc.total_amount = 0;
        vm.transaction_line.forEach((obj) => {
          vm.formDoc.total_amount += parseFloat(obj.amount);
        })
      },

      handlePayment(transaction_id){
        this.$store.dispatch('updateEcoBusinessDialogPayment', {dialog: true, transaction_id: transaction_id, operation: 'purchase_order', supplier_id:''});
      },

      handleSearch(){
        this.fetchDataTable();
      }

    },

    computed: {
      /** base on transaction line */
      enabledUser(){
          if(this.transaction_line.length){ return true; }
          return false;
      },

      isBeeOperator() {
        return ['beeOperator', 'employee'].includes(this.$store.state.userDoc.type);
      },
      dialogPayment(){
        return this.$store.state.outsideBusinessPayment.dialog;
      }
    },
    watch: {
      dialogPayment(val){
        if(! val){
          this.fetchDataTable();
        }
      },
      
      "filterDoc.category_id"(val) {
        let vm = this;
        if(vm.formDoc.currency_code && val){
          vm.fetchListProdctOutsideEco({
            category_id: val,
            contact_id: this.$store.state.userDoc.contact_id,
            currency_code: this.formDoc.currency_code,
            client_type: '',
            type: '',
            limit: vm.noLimit,
            offset: vm.currentPage,
            search: ''
          });
        }
      },

      "filterDoc.product_id"(val) {
        let vm = this;
        vm.addTransactionLine(val);
      },

      "formDoc.currency_code"(val) {
        let vm = this;
        vm.transaction_line.forEach((d) => {
          vm.updateTransactionLine(d);
        });
        vm.currency_symbol = vm.getCurrencySymbol(val);
        this.fetchCategoryOption(this.$store.state.userDoc.contact_id, '');
      },
      
      currentPage() {
        this.loading = true;
        this.fetchDataTable();
      },
      itemsPerPage() {
        this.loading = true;
        this.fetchDataTable();
      },
      dialog(val) {
        if (val === false) { this.reset(); }
        else {
          this.fetchListWalkinMember('supplier');
          this.fetchCurrencyOption();
        }
      }
    },
  };
</script>
